<template>
    <div
        class="overflow-y-auto [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-gray-300 dark:[&::-webkit-scrollbar-thumb]:bg-neutral-500 [&::-webkit-scrollbar-track]:rounded-full [&::-webkit-scrollbar-track]:bg-gray-100 dark:[&::-webkit-scrollbar-track]:bg-neutral-700 [&::-webkit-scrollbar]:w-2"
        ref="container">
        <slot />
    </div>
</template>
<script setup>
    import { ref, onMounted } from 'vue'

    const container = ref(null)
    const emit = defineEmits(['mounted'])
    onMounted(() => {
        if (container.value) {
            emit('mounted', container.value)
        }
    })
</script>
